module.exports = __webpack_public_path__ + "img/zuoyebang.c67c3201.png";